@let product = this.product();
@let isWithinRevocationPeriod = this.isWithinRevocationPeriod(product);

<form [formGroup]="form">
    <div class="modal-body">
        <div class="content">
            <div class="title">
                {{
                    (isWithinRevocationPeriod
                        ? 'REVOCATION_PRODUCT_WARRANTY.MODAL_TITLE'
                        : 'CANCEL_PRODUCT_REGISTRATION.MODAL_TITLE'
                    ) | translate
                }}
            </div>
            <!-- eslint-disable @nx/workspace-ebiz-no-inner-html -->
            <div
                class="message"
                [innerHtml]="
                    (isWithinRevocationPeriod
                        ? 'REVOCATION_PRODUCT_WARRANTY.MODAL_MSG'
                        : 'CANCEL_PRODUCT_REGISTRATION.MODAL_MSG'
                    ) | translate: { productName: product.itemNo }
                "
            ></div>
            <!-- eslint-enable @nx/workspace-ebiz-no-inner-html -->
        </div>

        <div class="product-info">
            <div>
                <div class="label">{{ 'PRODUCT' | translate }}</div>
                <div class="data">{{ product.itemNo }}</div>
            </div>
            <div>
                <div class="label">{{ 'PRODUCT_ID' | translate }}</div>
                <div class="data">{{ product.productId }}</div>
            </div>
            <div>
                <div class="label">
                    {{
                        (isWithinRevocationPeriod
                            ? 'REVOCATION_PRODUCT_WARRANTY.WARRANTY_REVOCATION_DATE'
                            : 'CANCEL_PRODUCT_REGISTRATION.WARRANTY_CANCEL_DATE'
                        ) | translate
                    }}
                </div>
                <div class="data">{{ getEndDate(product) | date: 'dd.MM.yyyy' }}</div>
            </div>

            @if (!isWithinRevocationPeriod) {
                <warema-input-field class="cancellation-reason" [hasError]="form.invalid">
                    <warema-field-label [text]="'CANCEL_PRODUCT_REGISTRATION.MODAL_CANCEL_REASON' | translate" />
                    <textarea formControlName="cancellationReason" [maxLength]="cancellationReasonMaxLength"></textarea>
                </warema-input-field>
            }
        </div>

        <div class="actions">
            <warema-button
                type="secondary"
                [text]="'CANCEL' | translate"
                (click)="cancel()"
                (keydown.enter)="cancel()"
                (keydown.space)="cancel()"
            />
            <warema-button
                [disabled]="!isWithinRevocationPeriod && form.invalid"
                [text]="
                    (isWithinRevocationPeriod
                        ? 'REVOCATION_PRODUCT_WARRANTY.MODAL_CONFIRM_BUTTON'
                        : 'CANCEL_PRODUCT_REGISTRATION.MODAL_CONFIRM_BUTTON'
                    ) | translate
                "
                (click)="confirm()"
                (keydown.enter)="confirm()"
                (keydown.space)="confirm()"
            />
        </div>
    </div>
</form>
